import { render, staticRenderFns } from "./NewsSlide.vue?vue&type=template&id=3babbe17&scoped=true"
import script from "./NewsSlide.vue?vue&type=script&lang=js"
export * from "./NewsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babbe17",
  null
  
)

export default component.exports